// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2UQYA","clinicsSelect":"TableHeading_clinicsSelect__3ssJ2"};